import http from '../helpers/http';

const HireAgreements = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async () => {
      const result = await http.get(`/hire-agreements`, {
        headers,
      });
      return result.data;
    },
    show: async (id: string) => {
      const result = await http.get(`/hire-agreements/${id}`, {
        headers,
      });
      return result.data;
    },
    create: async (body: any) => {
      const result = await http.post(`/hire-agreements`, body, { headers });
      return result.data;
    },
    update: async (id: string, body: { name?: string; addSignaturePage?: boolean; category?: string }) => {
      const result = await http.patch(`/hire-agreements/${id}`, body, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/hire-agreements/${id}`, {
        headers,
      });
      return result.data;
    },
    file: async (hireAgreementId: string, body: FormData) => {
      const headersConfig = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/hire-agreements/${hireAgreementId}/file`, body, headersConfig);
      return result.data;
    },
    assignEmployees: async (id: string, body: { employeeIds: string[] }) => {
      const result = await http.post(`/hire-agreements/${id}/assign`, body, { headers });
      return result.data;
    },
  };
};

export default HireAgreements;
